import { useFormik } from "formik";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { mapStates } from "../../../constants/mapRegions";

import { Context } from "../../../context/context";
import LeadService from "../../../services/leadService";
import { validLeadConvert } from "../../../services/leadValidation";
import sessionTracking from "../../../services/sessionTracking";
import { userQlFlow } from "../../../services/userQLFlow";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import { getCookie } from "../../../utils/cookie";
import { myScroll } from "../../../utils/myScroll";

const UseConnectWithUs = () => {
  const {
    showSnackbar,
    hideStoryForm,
    updateUserQlData,
    showReviewStoryDrawer,
  } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const state = useContext(Context);

  const leadIntent = "HIGH_INTENT";

  let cacheInfo = getCookie("user_verified")
    ? JSON.parse(getCookie("user_verified"))
    : "";

  const navigate = useRouter();

  const form = useFormik({
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: {
      mobile: cacheInfo?.phone ?? "",
    },

    validate: (values) => {
      const errors = {};

      if (!values?.mobile?.toString()) {
        errors.mobile = "Mobile Number is Mandatory";
      }
      if (values?.mobile?.toString()?.length !== 10) {
        errors.mobile = "Enter a valid 10 digit Mobile Number";
      }
      if (values?.mobile && values?.mobile[0] < 5) {
        errors.mobile = "Enter Valid Mobile Number";
      }

      const ipInformation = localStorage.getItem("geoLocation")
        ? JSON.parse(localStorage.getItem("geoLocation"))
        : {};

      if (values?.mobile?.toString()?.length === 10) {
        let payload = {
          phoneNumber: values?.mobile,
          connectType: "brand consult form",
          type: "brand consult form",
          cityInfo: ipInformation?.city,
          geoInfo: ipInformation,
        };
        sendAnalytics("v2_lead_form_entered_mobile", payload, "en");

        const leadPayload = {
          name: "",
          phone: values?.mobile,
          state: mapStates[ipInformation?.countryRegion] ?? "Others",
          leadIntent: leadIntent,
          subSource: "brand consult form",
        };

        // param: leadpayload, analyticsPayload
        validLeadConvert(leadPayload, payload);
      }

      return errors;
    },

    onSubmit: (values) => {
      const payload = {
        phone: values?.mobile,
        pan: "",
        pincode: "",
        dob: "",
        optedExchange: "",
        language: "",
        refNumber: "",
        leadIntent: leadIntent,
        subSource: "brand consult form",
        autoAssign: false,
        state: "Karnataka",
      };
      setLoading(true);
      const analyticsPayload = {
        number: values?.mobile,
        type: state?.showStoryFormValue
          ? "brand_turno_popup_form"
          : "brand_turno_expert_form",
        brandUrl: navigate?.pathname,
      };

      LeadService(payload)
        .then((response) => {
          // hideStoryForm();
          sendAnalytics(
            "reserve_vehicle_button_clicked",
            analyticsPayload,
            "en"
          );
          showSnackbar("We will get back to you soon!!", "success");
          setLoading(false);
          const sessionInfo = {
            leadUuid: response?.data?.uuid,
            newSession: false,
            formSubmitted: true,
            leadIntent: "HIGH_INTENT",
          };

          sessionTracking(sessionInfo);
          hideStoryForm();
          const Paths = [
            "passenger-vehicles",
            "goods-electric-commercial",
            "electric-passenger",
            "3w-ev-emi-11k-passenger",
          ];
          const isPathMatched = Paths.some((path) =>
            navigate?.pathname?.includes(path)
          );
          if (!isPathMatched) {
            navigate.push("/");
          }
          setTimeout(() => {
            myScroll(0, 700, "smooth");
          }, [4000]);

          // Enable QL Lead flow
          userQlFlow(state, updateUserQlData, showReviewStoryDrawer);
        })
        .catch(() => {
          showSnackbar(
            "Oops, something went wrong. Please try again later.",
            "error"
          );
        });
    },
  });

  return {
    form,
    loading,
  };
};

export default UseConnectWithUs;
